import { render, staticRenderFns } from "./keyword.vue?vue&type=template&id=3ec1bbfb&scoped=true&lang=true&"
import script from "./keyword.vue?vue&type=script&lang=js&"
export * from "./keyword.vue?vue&type=script&lang=js&"
import style0 from "./keyword.vue?vue&type=style&index=0&id=3ec1bbfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec1bbfb",
  null
  
)

export default component.exports